import { render } from "./Item.vue?vue&type=template&id=76b77b5e"
import script from "./Item.vue?vue&type=script&lang=js"
export * from "./Item.vue?vue&type=script&lang=js"

import "./Item.vue?vue&type=style&index=0&id=76b77b5e&lang=scss"

import exportComponent from "/opt/boarddata/boarddata.io/django/templates/frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__